import {
  Component, Input, OnInit,
} from '@angular/core';
import { TextInputComponent } from '@amaris/lib-highway/components/forms/text-input';
import { FormControl } from '@angular/forms';
import {
  Router, RouterLink, RouterLinkActive, RouterOutlet,
} from '@angular/router';
import { debounceTime } from 'rxjs';
import { Patient } from '../../../models/patient.model';
import { PatientsApiService } from '../../../services/apis/patients-api/patients-api.service';
import { ConsultationsApiService } from '../../../services/apis/consultations-api/consultations-api.service';
import { forkJoin } from 'rxjs';
import { faUser,faClipboardList	 } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { PatientExtended } from '../../../models/patient-extended.model';
import { ConsultationListItem } from '../../../models/consultations-list-item.model';

@Component({
  selector: 'app-wide-search-input',
  standalone: true,
  imports: [TextInputComponent, RouterOutlet, RouterLink, RouterLinkActive, FontAwesomeModule],
  templateUrl: './app-wide-search-input.component.html',
  styleUrl: './app-wide-search-input.component.scss',
})
export class AppWideSearchInputComponent implements OnInit {
  @Input() name: string;
  @Input() placeholder: string;

  fasUser = faUser;
  fasClipboardList = faClipboardList	;

  public patients: Patient[] = [];
  public consultations: ConsultationListItem[] = [];
  public formControl: FormControl = new FormControl();
  public inputFocused: boolean = false;
  public fetchedPatients: PatientExtended[] = [];

  constructor(
    private readonly patientApiService: PatientsApiService,
    private readonly consultationApiService: ConsultationsApiService,
    private readonly router: Router,
  ) {}

  ngOnInit(): void {
  this.formControl.valueChanges
    .pipe(debounceTime(250))
    .subscribe((value: string) => {
      if (!value) {
        this.patients = [];
        this.consultations = [];
        return;
      }
      forkJoin({
        patients: this.patientApiService.getPatientsFiltered(value),
        consultations: this.consultationApiService.getConsultationsFiltered(value)
      }).subscribe(({ patients, consultations }) => {
        this.patients = patients;
        this.consultations = consultations;
        this.consultations.forEach((consultation, index) => {
          const existingPatient = this.fetchedPatients.find((patient) => patient.id === consultation.patientId);
          if (existingPatient) {
            this.consultations[index].patient = existingPatient;
            return;
          }
          this.patientApiService.getPropertiesPatientById(consultation.patientId).subscribe((patient: PatientExtended) => {
            if (!patient) {
              this.consultations[index].patient = new PatientExtended();
            } else {
              this.fetchedPatients.push(patient);
              this.consultations[index].patient = patient;
            }
          });
        });
      });
    });
}

  patientClicked(patientId: string) {
    this.patients = [];
    this.formControl.setValue('');
    this.router.navigate(['/patients', patientId], { onSameUrlNavigation: 'reload' });
  }

  consultationClicked(consultationId: string) {
    let consultation = this.consultationApiService.getConsultationById(consultationId);
    let patientId = '';
    consultation.subscribe(value => {
      patientId = value.patientId;
      this.consultations = [];
      this.formControl.setValue('');
      this.router.navigate(['/patients', patientId,'consultations', consultationId], { onSameUrlNavigation: 'reload' });
    });
  }

  inputInteracted(focused: boolean) {
    if (!focused) {
      setTimeout(() => {
        this.inputFocused = focused;
      }, 250);
      return;
    }

    this.inputFocused = focused;
  }
}

